export function responseValueParser(resolver: Function, rawValue: string): void {
    try {
        resolver(JSON.parse(rawValue));
    } catch {
        resolver(rawValue);
    }
}
